import { Directive, inject, input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[name]',
  standalone: true,
})
export class UiNamedTemplateDirective {
  template = inject(TemplateRef<unknown>);
  name = input<string | undefined>(undefined);
}
